module.exports = __webpack_public_path__ + "img/folding-instructions.78eb82c7.png";